// Created on 2023-08-03
// Created by Vitaut Tryputsin
//
// Copyright (c) 2023 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
import { OccViewer } from "../viewer/viewer.js";
/**
 * Init [[PropertyManager]] in OccViewer.
 * @internal
*/
OccViewer.onInit((theModule) => {
    let aPropertyManager = theModule["_cppPropertyManager"]();
    theModule["_myPropertyManager"] = aPropertyManager;
    Object.defineProperty(aPropertyManager, "properties", {
        // add get property wrapper;
        get: function () {
            let aProps = this._cppProperties();
            const aWrapedProps = [];
            for (let i = 0; i < aProps.size(); i++) {
                aWrapedProps.push(aProps.get(i));
            }
            return aWrapedProps;
        },
        // add set property wrapper;
        set: function (theProps) {
            const aProps = new theModule["VectorObjectProperties"]();
            for (let i = 0; i < theProps.length; i++) {
                aProps.push_back(theProps[i]);
            }
            this._cppSetProperties(aProps);
            aProps.delete();
        },
    });
});
